import { store } from "src/store/store";
import { whatsNewContentVersionChanged } from "src/duck/actions";
import { currentContentVersion } from "src/scenes/WhatsNew/version-control";

export default function compareWhatsNewContentVersion(storedContentVersion) {
  let shouldShowWhatsNew = false;

  if (!storedContentVersion) {
    store.dispatch(whatsNewContentVersionChanged(currentContentVersion));
    return shouldShowWhatsNew;
  }

  if (storedContentVersion === currentContentVersion) {
    return shouldShowWhatsNew;
  }

  store.dispatch(whatsNewContentVersionChanged(currentContentVersion));
  shouldShowWhatsNew = true;
  return shouldShowWhatsNew;
}
